import React from 'react';
import RecipeList from '../components/RecipeList'


function Recipes() {
	return (
		<>
			<RecipeList />
		</>
	);
}

export default Recipes;